import { memo } from 'react';
import PropTypes from 'prop-types';
// next
import NextLink from 'next/link';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_JOBS } from '../../../routes/paths';
// components
import CompanyAvatar from '../../../components/CompanyAvatar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_8],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarCompany.propTypes = {
  isCollapse: PropTypes.bool,
};

function NavbarCompany({ isCollapse }) {
  const { user } = useAuth();

  return (
    <NextLink href={PATH_JOBS.root} passHref>
      <Link underline="none" color="inherit">
        <RootStyle
          sx={{
            ...(isCollapse && {
              bgcolor: 'transparent',
            }),
          }}
        >
          <CompanyAvatar
            sx={{
              backgroundColor: 'transparent',
              width: 32,
              height: 32,
            }}
          />

          <Box
            sx={{
              ml: 1.5,
              width: 1,
              overflow: 'hidden',
              transition: (theme) =>
                theme.transitions.create('width', {
                  duration: theme.transitions.duration.shorter,
                }),
              ...(isCollapse && {
                ml: 0,
                width: 0,
              }),
            }}
          >
            <Typography variant="subtitle2" sx={{ textOverflow: 'ellipsis', }} noWrap>
              {user?.employee?.company?.[0]?.name}
            </Typography>
          </Box>
        </RootStyle>
      </Link>
    </NextLink>
  );
}

export default memo(NavbarCompany);
